import { css } from '@emotion/react';
import { semantic_colors } from '../../foundation';
import { input_wrapper_base_css } from '../input/styles';

export const textarea_base_css = css`
  font: inherit;
  color: inherit;
  margin: 0;
  box-shadow: none;
  border-radius: 0;
  ${input_wrapper_base_css};
  resize: vertical;

  &::placeholder {
    color: ${semantic_colors.content.tertiary};
  }
`;
